<div class="card">
  <app-header
    titulo="Integração dos contratos"
    descricao="Realizar as buscas dos contratos no PIMS"
  ></app-header>

  <app-contratos [habilitaBusca]="true" [habilitaExportacao]="false" [habilitaIntegracao]="false"></app-contratos>

</div>
